<template>
  <div class="m-edition-asset-content-comments margin-top-xxlarge">
    <div class="align-items-center display-flex-row space-between margin-top-small">
      <div class="display-flex-row-center">
        <a
          href="#"
          :class="comentariosTipo === 3 ? 'text-color-academy-primary' : 'text-color-black-45'"
          @click.prevent="setComentariosTipo(3)"
        >
          <i :class="comentariosTipo === 3 && showLoadingState === 0 ? 'far fa-spinner fa-spin' : 'far fa-question-circle'"></i>
          {{ $t('mEditionAssetContentComments.submenu.questions') }}
        </a>
        <span class="font-size-xsmall font-weight-light margin-left-small margin-right-small text-color-black-35">|</span>
        <a
          href="#"
          :class="comentariosTipo === 1 ? 'text-color-academy-primary' : 'text-color-black-45'"
          @click.prevent="setComentariosTipo(1)"
        >
          <i :class="comentariosTipo === 1 && showLoadingState === 0 ? 'far fa-spinner fa-spin' : 'far fa-comment'"></i>
          {{ $t('mEditionAssetContentComments.submenu.comments') }}
        </a>
      </div>

      <p
        v-if="!comentariosRenderizados.length && showLoadingState > 0"
        class="font-size-small font-weight-light text-color-black-45"
      >
        {{ comentariosTipo === 1
          ? $t('mEditionAssetContentComments.messages.noComments')
          : $t('mEditionAssetContentComments.messages.noQuestions') }}
      </p>
      <p
        v-else-if="comentariosRenderizados.length && showLoadingState > 0"
        class="font-size-small font-weight-light text-color-black-65"
      >
        {{ comentariosTipo === 3
          ? `${$t('mEditionAssetContentComments.messages.questionsAmount.fisrtText')}
             ${comentariosRenderizados.length} de ${total} ${$t('mEditionAssetContentComments.messages.questionsAmount.secondText')}`
          : `${$t('mEditionAssetContentComments.messages.commentsAmount.fisrtText')}
             ${comentariosRenderizados.length} de ${total} ${$t('mEditionAssetContentComments.messages.commentsAmount.secondText')}`
        }}
      </p>
      <p
        v-else
        class="font-size-small font-weight-light text-color-success"
      >
        <i class="far fa-spinner fa-spin"></i>
        {{ $t('mEditionAssetContentComments.loading') }}
      </p>
    </div>

    <div>
      <MoleculeEditionAssetContentCommentsCreate
        :comentarios-tipo="comentariosTipo"
        :comment="null"
        :contenido="contenido"
        :is-reply="false"
      />
      <MoleculeEditionAssetContentCommentsReplies
        v-for="comentario in comentariosRenderizados"
        :key="comentario.id"
        :comentarios-tipo="comentariosTipo"
        :comment="comentario"
        :contenido="contenido"
        :is-child="false"
      />
      <span
        v-show="total > 0 && showLoadingState > 0"
        class="align-items-baseline display-flex-row font-size-small font-weight-light justify-content-center margin-auto margin-bottom-xxlarge text-color-black-65 width-fit-content"
      >
        {{ `Mostrando ${comentariosRenderizados.length} de ${total}` }}
        {{ comentariosTipo === 3
          ? $t('mEditionAssetContentComments.messages.questionsAmount.secondText')
          : $t('mEditionAssetContentComments.messages.commentsAmount.secondText')
        }}
      </span>
      <a
        v-show="comentarios.length"
        class="align-items-baseline display-flex-row justify-content-center margin-auto margin-bottom-xxlarge text-color-academy-primary width-fit-content"
        href="#"
        @click.prevent="loadMsgs"
      >
        <span class="font-size-xsmall margin-right-xsmall">
          <i class="far fa-arrow-down"></i>
        </span>
        Ver más
        {{ comentariosTipo === 3
          ? $t('mEditionAssetContentComments.messages.questionsAmount.secondText')
          : $t('mEditionAssetContentComments.messages.commentsAmount.secondText')
        }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContentComments',

  components: {
    MoleculeEditionAssetContentCommentsCreate: () => import('@/components/molecules/MoleculeEditionAssetContentCommentsCreate'),
    MoleculeEditionAssetContentCommentsReplies: () => import('@/components/molecules/MoleculeEditionAssetContentCommentsReplies')
  },

  data () {
    return {
      comentarios: [],
      comentariosRenderizados: [],
      comentariosTipo: 3,
      total: 0,
      uploadData: false,
      showLoadingState: 0
    }
  },

  computed: {
    contenido () {
      return Object.assign({}, this.$store.getters.getProyectContents[0])
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    '$store.getters.SelectedNode' () {
      this.showLoadingState = 0
      this.readContenidoComentarios()
    },

    updatedData () {
      this.readContenidoComentarios()
    }
  },

  created () {
    this.readContenidoComentarios()
  },

  methods: {
    loadMsgs () {
      this.comentariosRenderizados = this.comentariosRenderizados.concat(this.comentarios.splice(0, 10))
    },

    readContenidoComentarios () {
      this.$services.read('contenido', 'readContenidoComentarios', {},
        [this.contenido.id, this.$store.getters.getSelectedNode.id],
        { tipo_comentario: this.comentariosTipo })
        .then(response => {
          this.comentarios = []
          this.comentariosRenderizados = []
          this.comentarios = response.data
          this.total = this.comentarios.length
          this.comentariosRenderizados = this.comentariosRenderizados.concat(this.comentarios.splice(0, 10))
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    setComentariosTipo (tipo) {
      this.comentariosTipo = tipo
      this.showLoadingState = 0
      this.comentarios = []
      this.comentariosRenderizados = []
      this.readContenidoComentarios()
    }
  }
}
</script>
